import { TemplatePage } from './types';

const lyricPage: TemplatePage = {
  header: {
    color: '#D4BAA9',
    icon: 'images/video-templates/lyric_video.jpg',
    title: 'Lyric Video Templates Collection',
    title_meta: '20+ Lyric Video Templates - Editable and Free',
    description_meta:
      'Take your artistic creativity to the next level with Wave.video’s 20+ beautiful lyric video templates. ' +
      'Promote a new music album or upcoming concert easily.',
    description:
      'Take your artistic creativity to the next level with the help of these 20+ beautiful lyric video ' +
      'templates. Promote a new music album, spread the word about an upcoming concert, or simply share your ' +
      'favorite tunes with unique and attention-grabbing lyric videos.'
  },
  footer: {
    category: 'lyric',
    description:
      'Wave.video’s collection of lyric video templates eases the process of creating stunning videos for ' +
      'your website, blog, social media, or email newsletter. All the templates are free and easy to customize ' +
      'to suit your brand’s goals.'
  },
  content: [
    {
      type: 'templates',
      title: 'Lyric Video ',
      search: { name: 'lyric' }
    },
    {
      type: 'stocks',
      title: 'lyric',
      search: { name: 'lyric' }
    },
    { type: 'calendar' }
  ]
};

export default lyricPage;
